import { useEffect, useState } from 'react'
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import Pagination from '@mui/material/Pagination'
import { Button, useNotify, useTranslate } from 'react-admin'
import { useNavigate, useParams } from 'react-router'
import Api from './Apis/api.service'
import moment from 'moment'
import Alert from './components/alert'
import UpsertFileButton from './components/file_upload'
import FileWithContext from './models/file_with_context'

export const ExtranetPrestas = () => {
  const { ticket_token } = useParams()
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [total, setTotals] = useState(1)
  const [providerId, setProviderId] = useState(null)
  const notify = useNotify()
  const navigate = useNavigate()
  const translate = useTranslate()
  const getInterventions = async () => {
    // prepare query params pagination
    const params = { page }
    // call api get interventions presta by ticket_token
    const res = await Api.prestas.getInterventionsByToken(ticket_token, params)
    console.log({ res })
    if (res.status == 200) {
      setData(() => {
        return res.data.data
      })
      setTotals(() => {
        return res.data.pagination.totalPages
      })
      setProviderId(() => {
        return res.data.providerId
      })
    } else {
      console.log(res.data)
    }
  }
  useEffect(() => {
    getInterventions()
  }, [page])

  return (
    <div style={{ padding: '16px 0' }}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={11} md={11}>
          <Alert>
            Bienvenue sur votre espace global Manda (Ex-Hello Syndic). Vous
            trouverez ici l'ensemble des demandes, encore non clôturées, vous
            concernant.
          </Alert>
          <TableContainer component={Paper} style={{ marginTop: '16px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={7} align={'left'}>
                    <h2>Récapitulatif de toutes les interventions</h2>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>N° ticket</TableCell>
                  <TableCell align="left">Type</TableCell>
                  <TableCell align="left">Description</TableCell>
                  <TableCell align="left">Date de la demande</TableCell>
                  <TableCell align="left">Etape</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row) => (
                  <TableRow
                    key={row.id}
                    style={{
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    <TableCell>#{row.id}</TableCell>
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.libelle}</TableCell>
                    <TableCell align="left">
                      {moment(row.created).format('MM/DD/YYYY')}
                    </TableCell>
                    <TableCell align="left">{row.status}</TableCell>
                    <TableCell align="left">
                      <UpsertFileButton
                        fullWidth
                        basePath="/"
                        expectProvider={true}
                        resource="file_with_context"
                        documentType={
                          FileWithContext.DOCUMENT_TYPE.INTERVENTION
                        }
                        copro_id={row?.copro_id}
                        provider={providerId}
                        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                        linkable_type="tickets"
                        linkable_id={row.id}
                        defaultValue={
                          row?.fwc?.other_documents
                            ? row.fwc.other_documents
                            : []
                        }
                        upload_by={row.token_internal_id}
                        upload_by_type={'prestataires'}
                        validCategories={[
                          FileWithContext.CATEGORY.TECHNICAL,
                          FileWithContext.CATEGORY.ACCOUNTING,
                        ]}
                        validTypes={[
                          FileWithContext.TYPE.INTERVENTION_REPORT,
                          FileWithContext.TYPE.QUOTE,
                          FileWithContext.TYPE.INVOICE,
                        ]}
                        saveResult={(result) => {
                          if (
                            result.accepted_files &&
                            result.accepted_files.length > 0
                          ) {
                            notify(
                              translate('hs.file.success.upload_file'),
                              'success'
                            )
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        label="Afficher"
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          navigate(`/ext_tickets/${row.token}`)
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'right',
                padding: 10,
              }}
            >
              <Pagination
                count={total}
                color="primary"
                page={page}
                onChange={(event, value) => {
                  setPage(value)
                }}
              />
            </Box>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  )
}
